<div class="calendly-inline-widget"
     [attr.data-url]="_url"
     style="
     min-width: min(90vw, 1920px);
     height: 1200px;
     margin: 0 auto;"></div>
